export const COMMISSIONING_PHASE_KEYS = Object.freeze({
  DEVICE_OVERVIEW: "01_DEVICE_OVERVIEW",
  GRID_METER: "02_GRID_METER",
  METERS: "03_METERS",
  BATTERIES: "04_BATTERIES",
  SOLAR_INVERTERS: "05_SOLAR_INVERTERS",
  FINAL_VERIFICATION: "06_FINAL_VERIFICATION",
});
